// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1_tax_category.ml",
  98,
  6
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [[
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "to_int"
                            ],
                            [
                              /* Function */ 0,
                              "from_int"
                            ],
                            [
                              /* Function */ 0,
                              "from_int_exn"
                            ],
                            [
                              /* Function */ 0,
                              "to_string"
                            ],
                            [
                              /* Function */ 0,
                              "from_string_exn"
                            ]
                          ]
                        },
                        "TaxCategory"
                      ]]
                  },
                  "V1"
                ]]
            },
            "Control"
          ]]
      },
      "Tax"
    ]]
});

const Tax = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1_tax_category.ml",
  161,
  8
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "to_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int_exn"
                      ],
                      [
                        /* Function */ 0,
                        "to_string"
                      ],
                      [
                        /* Function */ 0,
                        "from_string_exn"
                      ]
                    ]
                  },
                  "TaxCategory"
                ]]
            },
            "V1"
          ]]
      },
      "Control"
    ]]
});

const Control = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1_tax_category.ml",
  222,
  10
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "to_int"
                ],
                [
                  /* Function */ 0,
                  "from_int"
                ],
                [
                  /* Function */ 0,
                  "from_int_exn"
                ],
                [
                  /* Function */ 0,
                  "to_string"
                ],
                [
                  /* Function */ 0,
                  "from_string_exn"
                ]
              ]
            },
            "TaxCategory"
          ]]
      },
      "V1"
    ]]
});

const V1 = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1_tax_category.ml",
  281,
  12
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "to_int"
          ],
          [
            /* Function */ 0,
            "from_int"
          ],
          [
            /* Function */ 0,
            "from_int_exn"
          ],
          [
            /* Function */ 0,
            "to_string"
          ],
          [
            /* Function */ 0,
            "from_string_exn"
          ]
        ]
      },
      "TaxCategory"
    ]]
});

const TaxCategory = Caml_module.init_mod([
  "proto/taxapis/gen/buhta_tax_control_v1_tax_category.ml",
  336,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "to_int"
    ],
    [
      /* Function */ 0,
      "from_int"
    ],
    [
      /* Function */ 0,
      "from_int_exn"
    ],
    [
      /* Function */ 0,
      "to_string"
    ],
    [
      /* Function */ 0,
      "from_string_exn"
    ]
  ]
});

function name(param) {
  return ".buhta.tax.control.v1.TaxCategory";
}

function to_int(param) {
  switch (param) {
    case /* TAX_CATEGORY_UNSPECIFIED */ 0 :
      return 0;
    case /* TAX_CATEGORY_ESP */ 1 :
      return 10;
    case /* TAX_CATEGORY_IPN */ 2 :
      return 110;
    case /* TAX_CATEGORY_OPV */ 3 :
      return 120;
    case /* TAX_CATEGORY_OPVR */ 4 :
      return 121;
    case /* TAX_CATEGORY_OOSMS */ 5 :
      return 130;
    case /* TAX_CATEGORY_SO */ 6 :
      return 210;
    case /* TAX_CATEGORY_VOSMS */ 7 :
      return 220;
    case /* TAX_CATEGORY_SN */ 8 :
      return 230;
  }
}

function from_int_exn(n) {
  if (n < 120) {
    if (n !== 0) {
      if (n !== 10) {
        if (n !== 110) {
          return Ocaml_protoc_plugin__Result.raise({
            NAME: "Unknown_enum_value",
            VAL: n
          });
        } else {
          return /* TAX_CATEGORY_IPN */ 2;
        }
      } else {
        return /* TAX_CATEGORY_ESP */ 1;
      }
    } else {
      return /* TAX_CATEGORY_UNSPECIFIED */ 0;
    }
  }
  if (n >= 220) {
    if (n !== 230) {
      if (n >= 221) {
        return Ocaml_protoc_plugin__Result.raise({
          NAME: "Unknown_enum_value",
          VAL: n
        });
      } else {
        return /* TAX_CATEGORY_VOSMS */ 7;
      }
    } else {
      return /* TAX_CATEGORY_SN */ 8;
    }
  }
  if (n === 210) {
    return /* TAX_CATEGORY_SO */ 6;
  }
  if (n >= 131) {
    return Ocaml_protoc_plugin__Result.raise({
      NAME: "Unknown_enum_value",
      VAL: n
    });
  }
  switch (n) {
    case 120 :
      return /* TAX_CATEGORY_OPV */ 3;
    case 121 :
      return /* TAX_CATEGORY_OPVR */ 4;
    case 122 :
    case 123 :
    case 124 :
    case 125 :
    case 126 :
    case 127 :
    case 128 :
    case 129 :
      return Ocaml_protoc_plugin__Result.raise({
        NAME: "Unknown_enum_value",
        VAL: n
      });
    case 130 :
      return /* TAX_CATEGORY_OOSMS */ 5;
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return from_int_exn(e);
  });
}

function to_string(param) {
  switch (param) {
    case /* TAX_CATEGORY_UNSPECIFIED */ 0 :
      return "TAX_CATEGORY_UNSPECIFIED";
    case /* TAX_CATEGORY_ESP */ 1 :
      return "TAX_CATEGORY_ESP";
    case /* TAX_CATEGORY_IPN */ 2 :
      return "TAX_CATEGORY_IPN";
    case /* TAX_CATEGORY_OPV */ 3 :
      return "TAX_CATEGORY_OPV";
    case /* TAX_CATEGORY_OPVR */ 4 :
      return "TAX_CATEGORY_OPVR";
    case /* TAX_CATEGORY_OOSMS */ 5 :
      return "TAX_CATEGORY_OOSMS";
    case /* TAX_CATEGORY_SO */ 6 :
      return "TAX_CATEGORY_SO";
    case /* TAX_CATEGORY_VOSMS */ 7 :
      return "TAX_CATEGORY_VOSMS";
    case /* TAX_CATEGORY_SN */ 8 :
      return "TAX_CATEGORY_SN";
  }
}

function from_string_exn(s) {
  switch (s) {
    case "TAX_CATEGORY_ESP" :
      return /* TAX_CATEGORY_ESP */ 1;
    case "TAX_CATEGORY_IPN" :
      return /* TAX_CATEGORY_IPN */ 2;
    case "TAX_CATEGORY_OOSMS" :
      return /* TAX_CATEGORY_OOSMS */ 5;
    case "TAX_CATEGORY_OPV" :
      return /* TAX_CATEGORY_OPV */ 3;
    case "TAX_CATEGORY_OPVR" :
      return /* TAX_CATEGORY_OPVR */ 4;
    case "TAX_CATEGORY_SN" :
      return /* TAX_CATEGORY_SN */ 8;
    case "TAX_CATEGORY_SO" :
      return /* TAX_CATEGORY_SO */ 6;
    case "TAX_CATEGORY_UNSPECIFIED" :
      return /* TAX_CATEGORY_UNSPECIFIED */ 0;
    case "TAX_CATEGORY_VOSMS" :
      return /* TAX_CATEGORY_VOSMS */ 7;
    default:
      return Ocaml_protoc_plugin__Result.raise({
        NAME: "Unknown_enum_name",
        VAL: s
      });
  }
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "to_int"
    ],
    [
      /* Function */ 0,
      "from_int"
    ],
    [
      /* Function */ 0,
      "from_int_exn"
    ],
    [
      /* Function */ 0,
      "to_string"
    ],
    [
      /* Function */ 0,
      "from_string_exn"
    ]
  ]
}, TaxCategory, {
  name: name,
  to_int: to_int,
  from_int: from_int,
  from_int_exn: from_int_exn,
  to_string: to_string,
  from_string_exn: from_string_exn
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "to_int"
          ],
          [
            /* Function */ 0,
            "from_int"
          ],
          [
            /* Function */ 0,
            "from_int_exn"
          ],
          [
            /* Function */ 0,
            "to_string"
          ],
          [
            /* Function */ 0,
            "from_string_exn"
          ]
        ]
      },
      "TaxCategory"
    ]]
}, V1, {
  TaxCategory: TaxCategory
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "to_int"
                ],
                [
                  /* Function */ 0,
                  "from_int"
                ],
                [
                  /* Function */ 0,
                  "from_int_exn"
                ],
                [
                  /* Function */ 0,
                  "to_string"
                ],
                [
                  /* Function */ 0,
                  "from_string_exn"
                ]
              ]
            },
            "TaxCategory"
          ]]
      },
      "V1"
    ]]
}, Control, {
  V1: V1
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "to_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int_exn"
                      ],
                      [
                        /* Function */ 0,
                        "to_string"
                      ],
                      [
                        /* Function */ 0,
                        "from_string_exn"
                      ]
                    ]
                  },
                  "TaxCategory"
                ]]
            },
            "V1"
          ]]
      },
      "Control"
    ]]
}, Tax, {
  Control: Control
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [[
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "to_int"
                            ],
                            [
                              /* Function */ 0,
                              "from_int"
                            ],
                            [
                              /* Function */ 0,
                              "from_int_exn"
                            ],
                            [
                              /* Function */ 0,
                              "to_string"
                            ],
                            [
                              /* Function */ 0,
                              "from_string_exn"
                            ]
                          ]
                        },
                        "TaxCategory"
                      ]]
                  },
                  "V1"
                ]]
            },
            "Control"
          ]]
      },
      "Tax"
    ]]
}, Buhta, {
  Tax: Tax
});

export {
  Imported$pmodules,
  Buhta,
}
/* Buhta Not a pure module */
